import './nav'
import '../shared/phone'
import '../shared/nav/collapsing_md_nav'
import '../shared/buyers_page_personalizer'
import './stripe_styling.js'

import '../shared/h4h_form'
import AddToCart from '../full-gpe/cart/add-to-cart'
import { store } from'../default/store'

import PhoneNumber from '../shared/phone.js'
import AddToCartForms from '../shared/add_to_cart_forms'
import HotelIndex from '../shared/add_to_cart_forms/h4h_hotels/hotel_index.vue'
import CartNav from '../shared/nav/nav_cart'
import Checkout from '../shared/checkout'
import AbTests from '../shared/ab_tests'
import DepositRedemptions from '../shared/deposit_redemptions'
import PackageTabs from '../shared/package_tabs'

import VueLoader from '../default/vue-loader'
import PriceFilter from '../shared/price_filter'
import '../shared/seating_chart_filter'
import '../shared/package_comparisons'
import '../shared/hide_map'
import '../shared/disable_reset'

document.addEventListener('turbo:load', () => {
  AddToCartForms.loadBottomForm()
  CartNav.addCartToNavbar()
  DepositRedemptions.findCustomerDeposits()
  Checkout.loadWithAddOn()
  AddToCart.AddToCart()
  AbTests.loadHotelAbTests()

  PackageTabs.loadTabs(782)

  if(document.getElementById('seating_chart_price')) {
    VueLoader.loadVueComponent(PriceFilter, document.getElementById('seating_chart_price'), store)
  }

  let phoneNumber = PhoneNumber()
  $('.navbar-right').append(`<li class="menu-item phone-contact"><a role="button" href="tel:${phoneNumber}"><div class="original">Questions? Call Us</div></a></li>`)

  VueLoader.loadVueComponent(HotelIndex, document.getElementById('hotelIndex'), store)
})
